import React from "react";
import { useSearchParams } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";

import EichrechtDecisionsPanel from "./EichrechtDecisionsPanel";
import ProvisioningQueue from "./ProvisioningQueue";
import ScreenHealthPanel from "./ScreenHealthPanel";
import StandInDecisionsPanel from "./StandInDecisionsPanel";
import UiHealthBanner from "./UiHealthBanner";
import UnmappedModelsPanel from "./UnmappedModelsPanel";
import { useUiHealth } from "./useUiHealth";

const TABS = ["requests", "models", "stand-ins", "eichrecht", "screens"];

/**
 * eRound provisioning (SOPS-148): the station requests by status, and the
 * wallbox models that block stations. Approving happens on the prospect page.
 * Screen health (SOPS-164) warns when eRound changed a screen the automation uses.
 */
const EroundProvisioningPage: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const active = Math.max(0, TABS.indexOf(params.get("tab") ?? "requests"));
  const health = useUiHealth();

  return (
    <div className="card">
      <h2 className="mt-0">eRound Provisioning</h2>
      <UiHealthBanner health={health} onOpen={() => setParams({ tab: "screens" })} />
      <TabView activeIndex={active} onTabChange={(e) => setParams({ tab: TABS[e.index] })}>
        <TabPanel header="Requests">
          <ProvisioningQueue />
        </TabPanel>
        <TabPanel header="Wallbox models">
          <UnmappedModelsPanel />
        </TabPanel>
        <TabPanel header="Stand-in decisions">
          <StandInDecisionsPanel />
        </TabPanel>
        <TabPanel header="Eichrecht decisions">
          <EichrechtDecisionsPanel />
        </TabPanel>
        <TabPanel header="Screen health">
          <ScreenHealthPanel />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default EroundProvisioningPage;
